import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { lookingToBuy } from "../../mock";
import { Button } from "../ui/button";
import Reveal from "../Reveal";

function InfoCard({ data }) {
  return (
    <div className="rounded-2xl border border-gold/20 bg-white p-7 shadow-sm hover:shadow-lg transition-shadow">
      <h3 className="font-display text-xl text-ink mb-5">{data.title}</h3>
      <ul className="space-y-3.5">
        {data.items.map((it) => (
          <li key={it.bold} className="flex items-start gap-3">
            <span className="grid place-items-center h-5 w-5 rounded-full bg-gold/15 text-gold-dark shrink-0 mt-0.5">
              <Check size={13} />
            </span>
            <span className="text-[15px] text-ink">
              <span className="font-semibold">{it.bold}</span> <span className="text-muted-foreground">{it.rest}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function LookingToBuy() {
  const scrollBook = () => document.getElementById("book-form")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="bg-gold-soft/40 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <h2 className="font-display text-3xl sm:text-4xl text-ink">{lookingToBuy.title}</h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">{lookingToBuy.intro}</p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal><InfoCard data={lookingToBuy.pay} /></Reveal>
          <Reveal delay={100}><InfoCard data={lookingToBuy.get} /></Reveal>
        </div>

        <Reveal delay={150}>
          <div className="mt-6 rounded-2xl bg-ink p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
            <div>
              <h3 className="font-display text-2xl text-white">{lookingToBuy.banner.title}</h3>
              <p className="mt-1.5 text-white/60 text-sm max-w-xl">{lookingToBuy.banner.note}</p>
            </div>
            <Button
              onClick={scrollBook}
              className="h-12 px-7 rounded-full bg-gold hover:bg-gold-light text-ink font-semibold whitespace-nowrap group"
            >
              Book Free Site Visit <ArrowRight size={17} className="ml-1.5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
